export default {
  baseUrl: 'https://apit9.lqfast.com',
  lqBaseUrl: 'https://t9bs.lqfast.com',
  lqAssetsServeUrl: 'https://lq-shangcheng.obs.cn-east-3.myhuaweicloud.com/t9bs'
}
